export default function ValidatePostCode(form) {
  let error = {};

  if (!form.address_post) {
    error.address_post = "Proszę wpisać swój kod pocztowy.";
  } else if (!/[0-9]{2}[-]([0-9]){3}$/i.test(form.address_post)) {
    error.address_post = "Proszę wpisać poprawny kod pocztowy.";
  }

  return error;
};